<template>
  <transition name="fade">
    <v-card class="pa-4 mb-4">
    <v-form @submit.prevent="checkForm">
      <v-text-field
        v-model="nombre"
        label="Nuevo nombre a mostrar"
        placeholder="Este será el nuevo nombre del usuario"
        :error-messages="errors.nombre"
        required
      ></v-text-field>

      <v-text-field
        v-model="username"
        label="Username"
        placeholder="Username"
        :error-messages="errors.username"
        required
      ></v-text-field>

      <v-row justify="end">
        <v-btn class="mr-2" @click="$emit('toggle', false)">Cancelar</v-btn>
        <v-btn color="success" type="submit">Guardar</v-btn>
      </v-row>
    </v-form>
  </v-card>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


<script>
export default {
  name: "editUsuario",
  components: {},
  props: ["hoteles", "editData"],
  data() {
    return {
      id: "",
      nombre: "",
      username: "",
      password: "",
      index_hotel: "",
      errors: [],
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre del usuario es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.username) {
        this.errors.username = "El usuario es obligatorio";
        valid = false;
      } else {
        this.errors.username = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let data_hotel = this.hoteles[this.index_hotel];
        this.$emit("successData", this.$data, data_hotel);
      }
    },
  },
  computed: {
    hotel() {
      return this.hoteles[this.index_hotel];
    },
  },
  watch: {},
  beforeMount: function () {},
  mounted() {
    this.username = this.editData.login;
    this.id = this.editData.id;
  },
};
</script>